import React from 'react';
import PropTypes from 'prop-types';
import Message from '../message/Message';
import {withLocalization} from 'epic-localization/src/context/LocalizationContext';


const SearchSection = ({onSearch, getMessage}) => {
    return (
        <div className="search-section">
            <div className="content-container">
            
                <div className="search-box-top"><Message code="epic.ut.tutorial.search.video" /></div>
                <div className="search-box">
                    <input type="text" className="form-control search" id="filter" placeholder={getMessage('epic.ut.tutorial.search.placeholder')} onChange={(val) => onSearch(val)}/>
                </div>
            </div>
        </div>
    )
}

SearchSection.propTypes = {
    onSearch: PropTypes.func,
    getMessage: PropTypes.func
}

export default withLocalization(SearchSection)

